import React, { useState, useEffect, useRef } from 'react';
import './Chatbot.css';
// import { analyzeSymptoms, predefinedSymptoms } from './healthawareness';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import NutritionLibrary from './NutritionLibrary';
import ChatbotTutorial from './ChatbotTutorial';
import YogaLibrary from './YogaLibrary';
import HealthLocator from "./HealthLocator";
import ConsentModal from '../ConsentModal';
const NUTRITION_MAINTENANCE = false; 


function Chatbot() {
    const { updateUser, user } = useAuth();

    const [loadingMealPlan, setLoadingMealPlan] = useState(false);
    const { isAuthenticated } = useAuth();

const [messages, setMessages] = useState(() => {
    if (isAuthenticated) {
        const saved = sessionStorage.getItem("reach_chat_messages");
        if (saved) return JSON.parse(saved);
    }

    return [{
        text: "Hello! Welcome to REACH. Please choose Nutrition (পুষ্টি) or Health Awareness (স্বাস্থ্য সচেতনতা) to get started.",
        fromUser: false,
        timestamp: new Date().toLocaleTimeString(),
        translatedText: null
    }];
});

const [currentStep, setCurrentStep] = useState(() => {
    if (isAuthenticated) {
        const savedStep = sessionStorage.getItem("reach_chat_step");
        return savedStep || "greeting";
    }
    return "greeting";
});
    const [userSelections, setUserSelections] = useState({});
    const [mealPlan, setMealPlan] = useState(null);
    const [isMuted, setIsMuted] = useState(false);
    const [healthInput, setHealthInput] = useState('');
    const [healthContext, setHealthContext] = useState({});
    const messagesEndRef = useRef(null);
    const [countdown, setCountdown] = useState(20);
    const [ageError, setAgeError] = useState('');
    const [healthLoading, setHealthLoading] = useState(false);
    const [healthCountdown, setHealthCountdown] = useState(20);
    const [showMaintenancePopup, setShowMaintenancePopup] = useState(false);
    const [showConsent, setShowConsent] = useState(
  localStorage.getItem("reach_user_consent") !== "true"
);

    // Bilingual prompts for rural context
    const inputPrompts = {
        age: { en: "Enter your age", bn: "আপনার বয়স কত?" },
        weight: { en: "Enter your weight (in kgs)", bn: "আপনার ওজন লিখুন (কেজিতে)" },
        height: { en: "Enter your height (in cm)", bn: "আপনার উচ্চতা লিখুন (সেন্টিমিটারে)" },
        gender: { en: "What is your gender?", bn: "আপনার লিঙ্গ কী?" },
        activity_level: { en: "What is your activity level?", bn: "আপনার দৈনন্দিন শারীরিক কার্যকলাপের স্তর কী?" },
        dietary_preferences: { en: "What is your dietary preference?", bn: "আপনার খাদ্যাভ্যাস কী?" },
        health_goal: { en: "What is your health goal?", bn: "আপনার স্বাস্থ্য সংক্রান্ত লক্ষ্য কী?" },
        disease_condition: { en: "Do you have any of these health conditions?", bn: "আপনার কি এই স্বাস্থ্য সমস্যা আছে?" },
        season: { en: "Which season is it currently?", bn: "এখন কোন ঋতু?" }
    };

    const buttonLabels = {
        Nutrition: "Nutrition (পুষ্টি)",
        "Health Awareness": "Health Awareness (স্বাস্থ্য সচেতনতা)",
        male: "Male (পুরুষ)",
        female: "Female (মহিলা)",
        sedentary: "Sedentary (আলসেমি/কম চলাফেরা)",
        "moderately active": "Moderately Active (মাঝারি কার্যকলাপ)",
        active: "Active (সক্রিয়)",
        "highly active": "Highly Active (অত্যন্ত সক্রিয়)",
        vegetarian: "Vegetarian (শাকাহারি)",
        "non-vegetarian": "Non-Vegetarian (মাংসাহারি)",
        weight_loss: "Weight Loss (ওজন কমানো)",
        muscle_gain: "Muscle Gain (পেশী বাড়ানো)",
        maintain_weight: "Maintain Weight (ওজন বজায় রাখা)",
        general_health: "General Health (সাধারণ স্বাস্থ্য)",
        growth_and_development: "Growth & Development (বৃদ্ধি ও উন্নয়ন)",
        fitness_and_endurance: "Fitness & Endurance (ফিটনেস ও সহনশীলতা)",
        energy_and_stamina: "Energy & Stamina (শক্তি ও সহনশীলতা)",
        improve_haemoglobin: "Improve Haemoglobin (হিমোগ্লোবিন বৃদ্ধি)",
        none: "None (কিছু না)",
        diabetes: "Diabetes (ডায়াবেটিস)",
        anaemia: "Anaemia (রক্তাল্পতা)",
        hypertension: "Hypertension (উচ্চ রক্তচাপ)",
        NAFLD: "NAFLD (লিভার চর্বি)",
        summer: "Summer (গ্রীষ্ম)",
        monsoon: "Monsoon (বর্ষা)",
        winter: "Winter (শীত)",
        spring: "Spring (বসন্ত)",
        autumn: "Autumn (শরৎ)"
    };
    console.log("Detected location:", user?.location);

  // ============================
    // LOCATION DETECTION (ADDED)
    // ============================
    useEffect(() => {
        if (!navigator.geolocation) return;
        if (user?.location) return;

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const res = await axios.get(
                        'https://nominatim.openstreetmap.org/reverse',
                        {
                            params: {
                                lat: pos.coords.latitude,
                                lon: pos.coords.longitude,
                                format: 'json',
                            },
                        }
                    );

                    const address = res.data.address || {};
                    const locationName =
                        address.city ||
                        address.town ||
                        address.village ||
                        address.state;

                    if (locationName) {
                        updateUser({ location: locationName });
                    }
                } catch (err) {
                    console.error('Location lookup failed');
                }
            },
            () => {
                console.warn('User denied location access');
            }
        );
    }, [updateUser, user]);
    useEffect(() => {
        let timer;
        if (loadingMealPlan && countdown > 0) {
            timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
        } else if (!loadingMealPlan) {
            setCountdown(30);
        }
        return () => clearTimeout(timer);
    }, [loadingMealPlan, countdown]);

useEffect(() => {
    let timer;
    if (healthLoading && healthCountdown > 0) {
        timer = setTimeout(() => setHealthCountdown(prev => prev - 1), 1000);
    } else if (!healthLoading) {
        setHealthCountdown(20);
    }
    return () => clearTimeout(timer);
}, [healthLoading, healthCountdown]);


    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

useEffect(() => {
    if (isAuthenticated) {
        sessionStorage.setItem(
            "reach_chat_messages",
            JSON.stringify(messages)
        );
    }
}, [messages, isAuthenticated]);

useEffect(() => {
    if (isAuthenticated) {
        sessionStorage.setItem("reach_chat_step", currentStep);
    }
}, [currentStep, isAuthenticated]);




    // TTS Utility: NEVER auto-speak; speak ONLY on button click
    const speakText = (text, lang = 'en-US') => {
        if (isMuted || !('speechSynthesis' in window)) return;
        const synth = window.speechSynthesis;
        synth.cancel();
        let voices = synth.getVoices();
        let matchedVoice = voices.find(voice => voice.lang === lang);
        if (!matchedVoice && lang.startsWith('bn')) {
            matchedVoice = voices.find(voice => voice.lang.includes('bn') || voice.lang.includes('hi'));
        }
        if (!matchedVoice && voices.length > 0) matchedVoice = voices[0];
        const utterance = new window.SpeechSynthesisUtterance(text);
        utterance.lang = lang;
        if (matchedVoice) utterance.voice = matchedVoice;
        utterance.rate = 0.70;
        synth.speak(utterance);
    };

    const sendMessage = (text, fromUser = false, translatedText = null) => {
    const timestamp = new Date().toLocaleTimeString();
    setMessages(prev => [...prev, { text, fromUser, timestamp, translatedText }]);
};



// 🔹 ADD THIS RIGHT HERE
const formatMealPlanAdvanced = (mealPlan) => {

    let message = "🍽️ PERSONALIZED 3-DAY MEAL PLAN\n";
    message += "━━━━━━━━━━━━━━━━━━━━━━\n";

    Object.entries(mealPlan).forEach(([day, meals]) => {

        message += `\n📅 ${day.toUpperCase()}\n`;
        message += "──────────────────────\n";

        if (meals.breakfast)
            message += `🥣 Breakfast : ${meals.breakfast}\n`;

        if (meals.lunch)
            message += `🍛 Lunch     : ${meals.lunch}\n`;

        if (meals.snack)
            message += `🍎 Snack     : ${meals.snack}\n`;

        if (meals.dinner)
            message += `🍲 Dinner    : ${meals.dinner}\n`;

        message += "\n";
    });

    message += "━━━━━━━━━━━━━━━━━━━━━━\n";
    message += "💡 Stay hydrated and maintain balanced portions.\n";

    return message;
};

    // Translate message and add Bengali TTS button (NO auto-play)
    const handleTranslate = async (text, index) => {
        try {
            const res = await fetch('/translate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text, lang: 'bn' })
            });
            const data = await res.json();
            setMessages(prev =>
                prev.map((msg, i) => {
                    if (i === index) {
                        return { ...msg, translatedText: data.translated_text };
                    }
                    return msg;
                })
            );
        } catch (err) {
            alert("Translation failed.");
        }
    };

    // Meal Plan output as a single formatted message
    // const fetchMealPlan = async () => {
    //     sendMessage("Generating your personalized meal plan...");
    //     setLoadingMealPlan(true);
    //     try {
    //         const res = await fetch("/generate-meal-plan", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 age: userSelections.age,
    //                 gender: userSelections.gender?.toLowerCase(),
    //                 weight: userSelections.weight,
    //                 height: userSelections.height,
    //                 activity_level: userSelections.activity_level?.toLowerCase(),
    //                 dietary_preferences: userSelections.dietary_preferences?.toLowerCase(),
    //                 health_goal: userSelections.health_goal?.toLowerCase().replace(" ", "_"),
    //                 disease_condition: userSelections.disease_condition?.toLowerCase() || "none",
    //                 season: userSelections.season?.toLowerCase() || "monsoon"
    //             }),
    //         });

    //         const data = await res.json();
    //         setLoadingMealPlan(false);

    //         if (data.status === "success") {
    //             sendMessage(data.profile);
    //             let mealPlanMsg = "🍽️ 3-Day Meal Plan\n";
    //             Object.entries(data.meal_plan).forEach(([day, meals]) => {
    //                 mealPlanMsg += `\n${day.toUpperCase()}\n`;
    //                 ["breakfast", "lunch", "snack", "dinner"].forEach((mealType) => {
    //                     const dish = meals[mealType];
    //                     if (dish) mealPlanMsg += `${mealType}: ${dish}\n`;
    //                 });
    //             });
    //             sendMessage(mealPlanMsg.trim());
    //             setMealPlan(data.meal_plan);
    //             setCurrentStep("completed");
    //         } else {
    //             const errMsg = data.message || "⚠️ Could not generate meal plan.";
    //             sendMessage(`⚠️ ${errMsg}`);
    //         }
    //     } catch (err) {
    //         setLoadingMealPlan(false);
    //         sendMessage("❌ Server error while generating meal plan.");
    //     }
    // };



const fetchMealPlan = async () => {

    sendMessage("🧠 Analyzing your profile and generating your meal plan...");
    setLoadingMealPlan(true);
    setCountdown(20);

    try {
        const res = await fetch("/generate-meal-plan", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                age: userSelections.age,
                gender: userSelections.gender?.toLowerCase(),
                weight: userSelections.weight,
                height: userSelections.height,
                activity_level: userSelections.activity_level?.toLowerCase(),
                dietary_preferences: userSelections.dietary_preferences?.toLowerCase(),
                health_goal: userSelections.health_goal?.toLowerCase().replace(" ", "_"),
                disease_condition: userSelections.disease_condition?.toLowerCase() || "none",
                season: userSelections.season?.toLowerCase() || "monsoon"
            }),
        });

        const data = await res.json();

        // ⏳ FORCE 20 SECOND LOADING
        setTimeout(() => {

            setLoadingMealPlan(false);

            if (data.status === "success") {

                sendMessage(data.profile);

                const formattedMessage = formatMealPlanAdvanced(data.meal_plan);
                sendMessage(formattedMessage);

                setMealPlan(data.meal_plan);
                setCurrentStep("completed");

            } else {
                sendMessage("⚠️ Could not generate meal plan.");
            }

        }, 20000); // <-- EXACT 20 seconds

    } catch (err) {
        setLoadingMealPlan(false);
        sendMessage("❌ Server error while generating meal plan.");
    }
};



    const handleOptionClick = (key, value) => {
        setUserSelections(prev => ({ ...prev, [key]: value }));
        sendMessage(`${key}: ${value}`, true);

        // if (currentStep === 'greeting') {
        //     if (value === 'Nutrition') {
        //         setCurrentStep('age');
        //     } else {
        //         sendMessage("Let’s understand your health issue. You can choose from common symptoms or describe in your own words.");
        //         setCurrentStep('symptom_prompt');
        //     }
       if (currentStep === 'greeting') {
    if (value === 'Nutrition') {

        if (NUTRITION_MAINTENANCE) {
            setShowMaintenancePopup(true);
            return;
        }

        setCurrentStep('age');

    } else {
    setHealthLoading(true);

    // Wake GPU
    fetch('/wake-gpu', { method: 'POST' }).catch(err =>
        console.error("Wake up failed:", err)
    );

    // After 20 seconds switch to health chat
    setTimeout(() => {
        setHealthLoading(false);
        setCurrentStep('health_awareness');
        sendMessage("✅ Health AI is ready. Please describe your symptoms.", false);
    }, 20000);
}
        
        } else if (currentStep === 'age') {
            setCurrentStep('gender');
        } else if (currentStep === 'gender') {
            setCurrentStep('weight');
        } else if (currentStep === 'weight') {
            setCurrentStep('height');
        } else if (currentStep === 'height') {
            setCurrentStep('activity_level');
        } else if (currentStep === 'activity_level') {
            setCurrentStep('dietary_preferences');
        } else if (currentStep === 'dietary_preferences') {
            setCurrentStep('health_goal');
        } else if (currentStep === 'health_goal') {
            setCurrentStep('disease_condition');
        } else if (currentStep === 'disease_condition') {
            setCurrentStep('season');
        } else if (currentStep === 'season') {
            fetchMealPlan();
        }
    };

    // const handleHealthSubmit = () => {
    //     if (healthInput.trim()) {
    //         sendMessage(healthInput, true);

    //         const { responses, followUps, contextUpdate } = analyzeSymptoms(healthInput, messages, healthContext);

    //         responses.forEach(resp => sendMessage(resp));
    //         setHealthInput('');
    //         setHealthContext(prev => ({ ...prev, ...contextUpdate }));

    //         // If follow-ups are required, keep in health_awareness, else finish
    //         if (followUps && followUps.length > 0) {
    //             setCurrentStep('health_awareness');
    //         } else {
    //             setCurrentStep('completed');
    //         }
    //     }
    // };
// const handleHealthSubmit = async () => {
//     if (!healthInput.trim()) return;

//     const userMessage = healthInput;
//     sendMessage(userMessage, true);
//     setHealthInput('');

//     try {
//         const res = await fetch("/health-chat", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//                 message: userMessage,
//                 history: messages
//             })
//         });

//         const data = await res.json();
//         sendMessage(data.response);

//         // Stay in health awareness mode for multi-turn conversation
//         setCurrentStep("health_awareness");

//     } catch (err) {
//         sendMessage("❌ Unable to contact health assistant.");
//     }
// };
    const handleHealthSubmit = async (manualInput) => {
        const originalMessage = (typeof manualInput === 'string' ? manualInput : healthInput) || "";
if (!originalMessage.trim()) return;

sendMessage(originalMessage, true);
setHealthInput('');

// Detect if non-English characters exist
const isRegional = /[^\u0000-\u007f]/.test(originalMessage);

let messageToSend = originalMessage;

if (isRegional) {
    try {
        const translateRes = await fetch('/translate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                text: originalMessage,
                lang: 'en'
            })
        });

        const translateData = await translateRes.json();
        messageToSend = translateData.translated_text || originalMessage;

    } catch (err) {
        console.error("Translation failed, sending original.");
    }
}

        
        try {
            const res = await fetch("/health-chat", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
               message: messageToSend,
                 history: messages
                            })

            });

            const data = await res.json();

            // HANDLE WAKE-UP SCENARIO
            if (res.status === 202) {
                sendMessage("🔄 Powering on the AI Server... (This saves energy!). Please wait ~90 seconds and try again.");
                // Optional: You could set a timeout to auto-retry here if you wanted.
            } 
            else if (data.response) {
                sendMessage(data.response);
            } 
            else {
                sendMessage("⚠️ No response received.");
            }

            setCurrentStep("health_awareness");

        } catch (err) {
            console.error("Error:", err);
            sendMessage("❌ Network error. Please try again.");
        }
    };
    // Dynamic bilingual option buttons
    const renderButtons = () => {
    const optionsMap = {
        greeting: ["Nutrition", "Health Awareness"],
        gender: ["male", "female"],
        activity_level: ["sedentary", "moderately active", "active", "highly active"],
        dietary_preferences: ["vegetarian", "non-vegetarian"],
        health_goal: [
            "weight_loss", "muscle_gain", "maintain_weight", "general_health",
            "growth_and_development", "fitness_and_endurance",
            "energy_and_stamina", "improve_haemoglobin"
        ],
        disease_condition: ["none", "diabetes", "anaemia", "hypertension", "NAFLD"],
        season: ["summer", "monsoon", "winter", "spring", "autumn"]
    };

    // --- Show YES/NO ONLY if in a FOLLOW-UP flow ---
    if (
        (currentStep === 'symptom_prompt' || currentStep === 'health_awareness') &&
        healthContext &&
        healthContext.followUps &&
        Array.isArray(healthContext.followUps) &&
        healthContext.followUps.length > 0
    ) {
        return (
            <div className="choice-btns">
                <button className="option-btn" onClick={() => {
                    setHealthInput("yes");
                    // Optionally, auto-submit:
                    // handleHealthSubmit();
                }}>Yes</button>
                <button className="option-btn" onClick={() => {
                    setHealthInput("no");
                    // Optionally, auto-submit:
                    // handleHealthSubmit();
                }}>No</button>
            </div>
        );
    }

if (currentStep === 'symptom_prompt' || currentStep === 'health_awareness') {
    return null;
}

    // --- For all other nutrition steps ---
    if (optionsMap[currentStep]) {
        return (
            <div className="choice-btns">
                {optionsMap[currentStep].map((option, i) => (
                    <button key={i} onClick={() => handleOptionClick(currentStep, option)} className="option-btn">
                        {buttonLabels[option] ||
                            option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    </button>
                ))}
            </div>
        );
    }
    return null;
};


    const showRegenButton = currentStep === "completed" && mealPlan && (
        <button className="regen-btn" onClick={() => {
            fetchMealPlan();
        }}>🔄 Generate Another Meal Plan</button>
    );

// 🔐 BLOCK CHATBOT UNTIL USER AGREES
if (showConsent) {
  return (
    <ConsentModal onAgree={() => setShowConsent(false)} />
  );
}

    return (
        <div className="chatbot-page">
            <div className="chatbot-container">
                <div className="chat-window chatbot-modern-card">
                    <div className="messages rural-scroll">

    {messages.map((msg, i) => (
        <div key={i} className={`message ${msg.fromUser ? 'user' : 'bot'} modern-bubble`}>
            <div className="message-text">
                {msg.text.includes("PERSONALIZED 3-DAY MEAL PLAN") ? (
    <div className="meal-plan-card">
        {msg.text.split('\n').map((line, idx) => (
            <div key={idx}>{line}</div>
        ))}
    </div>
) : (
    msg.text.split('\n').map((line, idx) => (
        <div key={idx}>{line}</div>
    ))
)}

                {!msg.fromUser && (
                    <div className="msg-actions">
                        <button
                            className="translate-btn"
                            title="Translate to Bengali"
                            onClick={() => handleTranslate(msg.text, i)}
                        >
                            🌐
                        </button>

                        <button
                            className="translate-btn"
                            title="English TTS"
                            onClick={() => speakText(msg.text, 'en-US')}
                        >
                            🔊
                        </button>

                        <button
                            className="translate-btn"
                            title="Bengali TTS"
                            onClick={() =>
                                msg.translatedText
                                    ? speakText(msg.translatedText, 'bn-IN')
                                    : speakText(msg.text, 'bn-IN')
                            }
                        >
                            🔊(বাং)
                        </button>
                    </div>
                )}

                {msg.translatedText && (
                    <div className="translated-text">
                        {msg.translatedText}
                    </div>
                )}
            </div>

            <div className="timestamp">
                {msg.timestamp}
            </div>
        </div>
    ))}

    {/* ===== HEALTH AI LOADING SCREEN ===== */}
    {healthLoading && (
        <div className="ai-loading-screen">
            <div className="ai-loader-card">
                <div className="ai-loader-title">
                    Personalizing your experience...
                </div>

                <div className="ai-loader-sub">
    <div>
        Preparing medical reasoning engine • 
        Analyzing patterns • 
        Optimizing AI responses
    </div>
    <div style={{ marginTop: "6px", fontSize: "0.9em", color: "#556" }}>
        চিকিৎসা বিশ্লেষণ ব্যবস্থা প্রস্তুত করা হচ্ছে • 
        স্বাস্থ্য তথ্য বিশ্লেষণ করা হচ্ছে • 
        AI উত্তর উন্নত করা হচ্ছে
    </div>
</div>


                <div className="ai-progress-bar">
                    <div className="ai-progress-fill"></div>
                </div>

                <div className="ai-countdown">
                    {healthCountdown}s
                </div>
            </div>
        </div>
    )}

    <div ref={messagesEndRef} />

</div>


                    <div className="button-options">
                        {(inputPrompts[currentStep]) && (
                            <div className="input-prompt rural-prompt">
                                <strong>{inputPrompts[currentStep].en}</strong>
                                <span style={{ fontSize: "0.95em", color: "#556" }}> ({inputPrompts[currentStep].bn})</span>
                            </div>
                        )}

                        {["age", "weight", "height"].includes(currentStep) && (
                            <div className="input-step">
                                {currentStep === "age" ? (
                                    <>
                                        <input
                                            type="number"
                                            className="rural-input"
                                            placeholder="Enter your age"
                                            value={userSelections.age || ''}
                                            min={8}
                                            max={70}
                                            onChange={e => {
                                                const val = e.target.value;
                                                setUserSelections(prev => ({ ...prev, age: val }));
                                                if (val && (val < 8 || val > 70)) {
                                                    setAgeError("Allowed age is 8-70 years. অনুমোদিত বয়স ৮-৭০ বছর।");
                                                } else {
                                                    setAgeError('');
                                                }
                                            }}
                                        />
                                        <button
                                            onClick={() => {
                                                sendMessage(`Age: ${userSelections.age}`, true);
                                                setCurrentStep("gender");
                                            }}
                                            className="submit-btn"
                                            disabled={!userSelections.age || userSelections.age < 8 || userSelections.age > 70}
                                        >Submit</button>
                                        {ageError && <div className="error-msg" style={{ color: "red" }}>{ageError}</div>}
                                    </>
                                ) : currentStep === "weight" ? (
                                    <>
                                        <input
                                            type="number"
                                            className="rural-input"
                                            placeholder="Enter your weight (kgs)"
                                            value={userSelections.weight || ''}
                                            onChange={e =>
                                                setUserSelections(prev => ({ ...prev, weight: e.target.value }))
                                            }
                                        />
                                        <button onClick={() => {
                                            sendMessage(`Weight: ${userSelections.weight}`, true);
                                            setCurrentStep("height");
                                        }}
                                            className="submit-btn"
                                            disabled={!userSelections.weight}
                                        >Submit</button>
                                    </>
                                ) : (
                                    <>
                                        <input
                                            type="number"
                                            className="rural-input"
                                            placeholder="Enter your height (cm)"
                                            value={userSelections.height || ''}
                                            onChange={e =>
                                                setUserSelections(prev => ({ ...prev, height: e.target.value }))
                                            }
                                        />
                                        <button onClick={() => {
                                            sendMessage(`Height: ${userSelections.height}`, true);
                                            setCurrentStep("activity_level");
                                        }}
                                            className="submit-btn"
                                            disabled={!userSelections.height}
                                        >Submit</button>
                                    </>
                                )}
                            </div>
                        )}

                        {renderButtons()}

                        <button
                            onClick={() => setIsMuted(val => !val)}
                            className={`tts-btn ${isMuted ? 'tts-muted' : ''}`}
                        >
                            {isMuted ? '🔇 TTS Off' : '🔊 TTS On'}
                        </button>

                        {showRegenButton}
                    </div>

                 {!healthLoading && (currentStep === 'health_awareness' || currentStep === 'symptom_prompt') && (
                        <div className="health-input">
                            <input
                                type="text"
                                className="rural-input"
                                placeholder="Describe your symptoms..."
                                value={healthInput}
                                onChange={(e) => setHealthInput(e.target.value)}
                            />
                            <button className="submit-btn" onClick={handleHealthSubmit}>Submit</button>
                        </div>
                    )}

                                        {loadingMealPlan && (
    <div className="ai-loading-screen">
        <div className="ai-loader-card">

            <div className="ai-loader-title">
                Generating Your Personalized Nutrition Plan
            </div>

            <div className="ai-loader-sub">
                🔍 Matching dietary profile<br/>
                🥗 Optimizing seasonal foods<br/>
                📊 Balancing nutrients<br/>
            </div>

            <div className="ai-progress-bar">
                <div
                    className="ai-progress-fill"
                    style={{ width: `${(20 - countdown) * 5}%` }}
                ></div>
            </div>

            <div className="ai-countdown">
                {countdown}s
            </div>

        </div>
    </div>
)}
                </div>  

                
                {/* ===== CHATBOT TUTORIAL SECTION ===== */}
<div className="tutorial-wrapper-container">
    <ChatbotTutorial />
</div>

{/* ===== NUTRITION LIBRARY SECTION ===== */}
<div className="library-wrapper">
    <NutritionLibrary />
</div>
{/* ===== YOGA LIBRARY SECTION ===== */}
<div className="yoga-library-container">
    <YogaLibrary />
</div>
{/* ===== HEALTH LOCATOR SECTION ===== */}
<div className="health-locator-section">
    <HealthLocator />
</div>
{showMaintenancePopup && (
    <div className="maintenance-overlay">
        <div className="maintenance-card">
            <h2>🚧 Nutrition Under Maintenance</h2>

            <h2>
                The Nutrition AI is temporarily unavailable 
                for approximately <strong>3 hours</strong>.
            </h2>

            <h2>
                Please use the Health Awareness model instead.
            </h2>

            <div style={{ marginTop: "20px" }}>
                <button
                    className="submit-btn"
                    onClick={() => {
                        setShowMaintenancePopup(false);
                        setCurrentStep('health_awareness');
                        sendMessage("Please describe your symptoms.", false);
                    }}
                >
                    Go to Health Awareness
                </button>

                <button
                    className="cancel-btn"
                    onClick={() => setShowMaintenancePopup(false)}
                    style={{ marginLeft: "10px" }}
                >
                    Close
                </button>
            </div>
        </div>
    </div>
)}

            </div>  
        </div>     

    );
}

export default Chatbot;
